import styled from 'styled-components';

export const Wrapper = styled.form`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 440px;
  height: 46px;
  padding: 0 8px 0 44px;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 999px;
  box-shadow: var(--shadow-sm);
  transition: border-color 0.2s, box-shadow 0.2s, max-width 0.3s var(--ease);

  &:focus-within {
    border-color: var(--ink);
    box-shadow: 0 0 0 4px rgba(224, 68, 42, 0.15);
    max-width: 520px;
  }
`;

export const Icon = styled.svg`
  position: absolute;
  left: 16px;
  width: 18px;
  height: 18px;
  fill: none;
  stroke: var(--muted);
  stroke-width: 2.2;
  stroke-linecap: round;
`;

export const Input = styled.input`
  flex: 1;
  min-width: 0;
  height: 100%;
  border: 0;
  background: transparent;
  font-size: 15px;
  outline: none;

  &::placeholder {
    color: var(--muted);
  }

  &::-webkit-search-cancel-button {
    display: none;
  }
`;

export const Kbd = styled.kbd`
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  margin-right: 4px;
  border: 1px solid var(--line);
  border-radius: 7px;
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--muted);
  background: var(--bg);

  @media (hover: none) {
    display: none;
  }
`;

export const Clear = styled.button`
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 50%;
  background: var(--surface-2);
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: var(--line);
  }
`;
